/*eslint-disable*/
import React, {useContext} from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import styles from "~/assets/jss/material-dashboard-pro-react/components/footerStyle.js";
import {FormattedMessage} from "react-intl";
import AppInfoContext from "../../../context/appinfo-context";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const appCtx = useContext(AppInfoContext);
  const { fluid, white, rtlActive } = props;
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white,
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white,
  });
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href={appCtx.contactUrl} className={block}>
                <FormattedMessage defaultMessage="Contact" />
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href={appCtx.impressumUrl} className={block}>
                <FormattedMessage defaultMessage="Legal Notice" />
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href={appCtx.privacyUrl} className={block}>
                <FormattedMessage defaultMessage="Data protection" />
              </a>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          <a
            href={appCtx.infoUrl1}
            className={anchor}
            target="_blank"
          >
            {appCtx.footerCopyRight}
          </a>
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
};
